"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAIN_FRAME_ID = void 0;
exports.MAIN_FRAME_ID = '1';
